module.exports = __webpack_public_path__ + "img/20180228_130615-1024x768.d00ec6d5.jpg";